module.exports = __webpack_public_path__ + "media/6_4.a276c96e.wav";